import {
    SEND_WEBCHAT_MESSAGE,
    SEND_WEBCHAT_MESSAGE_FAILED,
    SEND_WEBCHAT_MESSAGE_SUCCESS,
} from './constants';

/**
 * Create an action of type SEND_WEBCHAT_MESSAGE
 *
 * @export {function} sendWebchatMessage
 * @returns {Object} - Action of type SEND_WEBCHAT_MESSAGE
 */
export function sendWebchatMessage (message: string) {
    return {
        type: SEND_WEBCHAT_MESSAGE,
        message,
    };
}

/**
 * Create an action of type SEND_WEBCHAT_MESSAGE_SUCCESS
 *
 * @export {function} sendWebchatMessageSuccess
 * @returns {Object} - Action of type SEND_WEBCHAT_MESSAGE_SUCCESS and the API data payload
 */
export function sendWebchatMessageSuccess () {
    return {
        type: SEND_WEBCHAT_MESSAGE_SUCCESS,
    };
}

/**
 * Create an action of type SEND_WEBCHAT_MESSAGE_FAILED
 *
 * @export {function} sendWebchatMessageFailed
 * @returns {Object} - Action of type SEND_WEBCHAT_MESSAGE_FAILED and the API data payload
 */
export function sendWebchatMessageFailed (error, errorCode) {
    return {
        type: SEND_WEBCHAT_MESSAGE_FAILED,
        error,
        errorCode,
    };
}
